var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"#4BEC66","rounded":"","dark":"","dense":""},on:{"click":function($event){return _vm.goToWhatsapp()}}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-whatsapp")]),_vm._v(" Precisando de ajuda? ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }